import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c5b652c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addNewModal",
  tabindex: "-1",
  "data-bs-backdrop": "true",
  "aria-labelledby": "addNewModal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Turn your manual tasks into digital blueprints", -1))
const _hoisted_6 = {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close",
  ref: "closeBtn"
}
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "list-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-1" }, "+ Module")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "A module is like a document, but with interactive components, such as forms, that you can distribute to your customers.", -1))
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-1" }, "+ Process")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "A process bundles different modules and gives you the possibility to group them by milestones.", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex w-100 justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "mb-1" }, "+ Sub Process")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, "A Sub Process consists of optional modules within a process. These can be optionally selected when rolling out to the customer..", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("button", _hoisted_6, null, 512)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop","prevent"])),
                class: "list-group-item list-group-item-action",
                "aria-current": "true",
                "data-bs-toggle": "modal",
                "data-bs-target": "#addModuleModal"
              }, _hoisted_12),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
                class: "list-group-item list-group-item-action",
                "data-bs-toggle": "modal",
                "data-bs-target": "#addProcessModal"
              }, _hoisted_15),
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"])),
                class: "list-group-item list-group-item-action",
                "data-bs-toggle": "modal",
                "data-bs-target": "#addSubProcess"
              }, _hoisted_18)
            ])
          ]),
          _hoisted_19
        ])
      ])
    ])
  ]))
}